import moment from "moment";
import React, { Component } from "react";

export default class DatePickerInput extends Component {
  inputRef = React.createRef();

  constructor(props) {
    super(props);
    const value = formatDate(props.value);
    this.state = {
      value,
      isValid: moment.utc(value, "MM/DD/YYYY", true).isValid(),
      error: null,
    };
  }

  focus = (options) => {
    this.inputRef.current?.focus(options);
  };

  blur = () => {
    this.inputRef.current?.blur();
  };

  componentDidUpdate(prevProps) {
    const value = formatDate(this.props.value);
    const prevValue = formatDate(prevProps.value);
    if (value !== prevValue) {
      const isValid = moment.utc(value, "MM/DD/YYYY", true).isValid();
      this.setState({ value, isValid, error: null });
    }
  }

  handleChange = (e) => {
    e.persist();
    e.target.value = formatDate(e.target.value);
    const { onChange, minDate, maxDate } = this.props;
    const { isValid, value, error } = validateDate(e.target.value, minDate, maxDate);
    e.target.value = value;
    onChange(e);
    setImmediate(() => this.setState({ value, isValid, error }));
  };

  handleBlur = (e) => {
    if (e.target.value === "") {
      return;
    }
    const { onChange, minDate, maxDate } = this.props;
    const { isValid, error } = validateDate(e.target.value, minDate, maxDate);
    if (isValid && !error) {
      return;
    }
    const value = "";
    onChange({ target: { value }, isDefaultPrevented: () => false });
    setImmediate(() => this.setState({ value, isValid, error }));
  };

  render() {
    const { onChange, maxDate, minDate, ...inputProps } = this.props;
    const value = this.state.value;
    return (
      <>
        <input
          ref={this.inputRef}
          {...inputProps}
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        {this.state.error && (
          <div className="app-validation-error">
            <div className="app-form-help with-errors">{this.state.error}</div>
          </div>
        )}
      </>
    );
  }
}

function validateDate(value, minDate, maxDate) {
  const date = moment.utc(value, "MM/DD/YYYY", true);
  const isValid = date.isValid();
  if (isValid) {
    const minDateUtc = minDate ? (moment.isMoment(minDate) ? minDate.clone().utc() : moment.utc(minDate)) : null;
    if (minDateUtc && date.isBefore(minDateUtc)) {
      return { isValid, value: "", error: `Date cannot be before ${minDateUtc.format("MM/DD/YYYY")}` };
    }
    const maxDateUtc = maxDate ? (moment.isMoment(maxDate) ? maxDate.clone().utc() : moment.utc(maxDate)) : null;
    if (maxDateUtc && date.isAfter(maxDateUtc)) {
      return { isValid, value: "", error: `Date cannot be after ${maxDateUtc.format("MM/DD/YYYY")}` };
    }
  }
  if (value.length === 10 && !isValid) {
    return { isValid, value: "", error: "Date is invalid" };
  }
  return { isValid, value, error: null };
}

function formatDate(value) {
  if (!value || moment.isMoment(value)) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, "");
  const month = onlyNums.slice(0, 2);
  const day = onlyNums.slice(2, 4);
  const year = onlyNums.slice(4, 8);
  if (onlyNums.length <= 2) {
    return month;
  }
  if (onlyNums.length <= 4) {
    return `${month}/${day}`;
  }
  return `${month}/${day}/${year}`;
}

export function selectedDate(date) {
  if (moment.isMoment(date)) {
    return date;
  }
  if (typeof date === "string") {
    const isoCalendar = /^(\d{4}-\d{2}-\d{2})(?:T.*)?$/.exec(date);
    if (isoCalendar && moment.parseZone(date, moment.ISO_8601, true).isValid()) {
      return moment.utc(isoCalendar[1], "YYYY-MM-DD", true);
    }
  }
  const utc = typeof date === "string" ? moment.utc(date, "MM/DD/YYYY", true) : moment.utc(date);
  if (utc.isValid()) {
    return utc;
  }
  return null;
}
